export default (el) => { // http://youmightnotneedjquery.com/
  const elBox = el.getBoundingClientRect();
  const docBox = document.documentElement.getBoundingClientRect();

  const left = elBox.left - docBox.left;
  const top = elBox.top - docBox.top;

  return { top, left };
};



// WEBPACK FOOTER //
// ./src/lib/dom/element-position.js